import { defineMessages } from 'react-intl';

const messages = defineMessages({
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  replaceAssetsBudgetDescTooltip: {
    id: 'I7+dRJ',
    defaultMessage:
      'Annual budget (often Capital Expense or CapEx) to replace or perform a major overhaul on assets and equipment that have reached the end of their economic and useful life. ',
  },
  estimatedRoi: {
    id: 'hxKOo2',
    defaultMessage: 'Estimated ROI',
  },
  reportTotalText: {
    id: 'hjHa0A',
    defaultMessage: 'Ready to move forward?',
  },
  footnoteOne3: {
    id: 'KLJgiR',
    defaultMessage:
      ' with factors comparable to your inputs based on customers’ reported data, consistent linear spend, and other technical and financial assumptions. There may be additional unaccounted for costs related to the use and deployment of MAS that are not accounted for with this calculator. For a more precise estimate, submit a request for more information to obtain a savings estimate unique to your environment. The results shown by the tool are provided for illustrative purposes only, may not be accurate or applicable to you, and will vary based on your particular business conditions, usage, and configurations and environment, among other factors. Results from the calculator should not be relied upon, are not a guarantee or commitment to you regarding any potential or actual financial results you may achieve, may not be incorporated into any contract, and will not create any liability or obligation for IBM. The calculator is provided on an “AS IS” basis, without warranty of any kind.',
  },
  footnoteOne2: {
    id: 'Gw/PBx',
    defaultMessage: ' results reported by a sample (PDF) of IBM customers',
  },
  footnoteOne1: {
    id: '7RkkyX',
    defaultMessage:
      'The estimated benefit potential is illustrative of results achieved by IBM clients with financial and operational asset maintenance profiles comparable to the inputs you provided. The results shown by this benefit estimator are provided for illustrative purposes only, may not be accurate or applicable to you, and will vary based on aspects such as your asset management maturity, current state capabilities, and type of assets in scope. Results from this calculator should not be relied upon or seen as a guarantee regarding the actual benefits you may achieve and will not create any liability or obligation for IBM. For a more specific exploration of the benefits of Maximo in the context of your operations, please contact your IBM Sales or Business Partner Representative.',
  },
  export_to_pdf: {
    id: 'TPO7t1',
    defaultMessage: 'Create detailed PDF',
  },
  mroOverSpendReduceDescTooltip: {
    id: '0d347Y',
    defaultMessage:
      'Estimated reduction in MRO inventory spend by increasing strategic and disciplined procurement of material and parts (e.g., reducing unnecessary spend for MRO inventory that is already on hand or paying price premiums for expedite shipping).',
  },
  lifeAssetsExtLabel: {
    id: 'bf5xVZ',
    defaultMessage: '% Reduction in CapEx Budget Need',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  reportTotalHeading: {
    id: '11KrYT',
    defaultMessage: 'Estimated annual total',
  },
  lifeAssetsExtDescTooltip: {
    id: 'jrYjW5',
    defaultMessage:
      'Estimated reduction in CapEx requirements to replace/overhaul assets by extending the average economic and useful life.',
  },
  extMaintenanceVendorSpendLabel: {
    id: 'y17fxD',
    defaultMessage: 'External Maintenance Vendor Spend',
  },
  replaceAssetsBudgetLabel: {
    id: 'KIgTZ/',
    defaultMessage: 'Annual CapEx Budget to Replace/Overhaul Assets',
  },
  benefit: {
    id: '45ZkgK',
    defaultMessage: 'Benefit',
  },
  caseStudy: {
    id: 'EOAeVW',
    defaultMessage: 'Case Study',
  },
  extMaintenanceVendorSpendDescTooltip: {
    id: 'XXZbPZ',
    defaultMessage:
      'Current annual spend with external maintenance vendors to provide maintenance services.',
  },
  reportTotalDisclaimer: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  startOver: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  asstMgmtToolsCostLabel: {
    id: 'Rgz9KA',
    defaultMessage: 'Annual Cost to Support Current Asset Mgmt Tools',
  },
  downTimeReduceDescTooltip: {
    id: 'fn5a0S',
    defaultMessage:
      'Estimated reduction in downtime due to increased availability and performance of assets.',
  },
  asstMgmtToolsCostReduceDescTooltip: {
    id: '60j+mP',
    defaultMessage:
      'Estimated cost reduction from sunsetting and consolidating disparate asset management related tools into one asset management platform. ',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  accordionTitle_6: {
    id: 'l5I6KL',
    defaultMessage: 'Rationalize asset management tools',
  },
  maintenancePersonProdLabel: {
    id: 'W5bHzC',
    defaultMessage: 'Estimated Maintenance Personnel Productivity Improvement',
  },
  accordionTitle_5: {
    id: 'LG9hno',
    defaultMessage: 'Reduce MRO parts and supplies cost',
  },
  reportHeading: {
    id: 'WXSfCt',
    defaultMessage: 'See your potential benefit',
  },
  accordionTitle_4: {
    id: 'wJphaF',
    defaultMessage: 'Extend useful life of assets',
  },
  estimatedTotal: {
    id: '11KrYT',
    defaultMessage: 'Estimated annual total',
  },
  accordionTitle_3: {
    id: 'Dgnwqr',
    defaultMessage: 'Reduce downtime cost',
  },
  assetUtilPerformanceTable: {
    id: 'Dgnwqr',
    defaultMessage: 'Reduce downtime cost',
  },
  accordionTitle_2: {
    id: 'YmJvtm',
    defaultMessage: 'Reduce external maintenance spend',
  },
  accordionTitle_1: {
    id: 'xRglVq',
    defaultMessage: 'Increase maintenance productivity',
  },
  pdfCompleted: {
    id: 'zzXs9O',
    defaultMessage: 'Your Export is completed',
  },
  pdfGenerated: {
    id: 'F9LZWa',
    defaultMessage: 'Your Export is being generated',
  },
  maintenanceFTEsLabel: {
    id: 'qTW+Kp',
    defaultMessage: 'Number of Maintenance Personnel (Full-Time-Equivalents)',
  },
  startOverButton: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  extMaintVendorSpendReduceLabel: {
    id: 'opcXik',
    defaultMessage: '% External Maintenance Vendor Spend Reduction',
  },
  downTimeHoursAnnualDescTooltip: {
    id: 'Pq2DIU',
    defaultMessage:
      'Number of hours per year that assets are not available due to maintenance related issues that adversely impact operations.',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  maintenancePersonProdDescTooltip: {
    id: '0qH0sv',
    defaultMessage:
      'Estimated average productivity improvement by reducing unnecessary maintenance activities and increasing the cost efficient execution of necessary tasks.',
  },
  annualMroSpendLabel: {
    id: 'nE/lrt',
    defaultMessage: 'Annual MRO Spend',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  inventoryCostReduceTable: {
    id: 'LG9hno',
    defaultMessage: 'Reduce MRO parts and supplies cost',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  maintenanceFTEsDescTootlip: {
    id: '/WSzMH',
    defaultMessage:
      'Number of Maintenance Personnel in scope across maintenance roles based on full-time-equivalent headcount. ',
  },
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  calculationMessage: {
    id: 'E1Gwsp',
    defaultMessage: 'Estimated 3-year savings',
  },
  asstMgmtToolsCostReduceLabel: {
    id: 'B/MevZ',
    defaultMessage: '% Reduction of Asset Mgmt Tools Support Cost',
  },
  maintenancePersonFTERateDescTooltip: {
    id: 'FV1smI',
    defaultMessage:
      'Average annual cost per maintenance personnel headcount (blended rate; fully loaded)',
  },
  itCostReduceTable: {
    id: 'l5I6KL',
    defaultMessage: 'Rationalize asset management tools',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  detailedReportButton: {
    id: 'M/8l3Y',
    defaultMessage: 'Detailed report',
  },
  contactUs: {
    id: 'zEVTyS',
    defaultMessage: 'Get more information',
  },
  stickyNavTitle: {
    id: 'qZL9Ww',
    defaultMessage: 'Estimated annual benefits',
  },
  widgetInfo2: {
    id: 'T23aUd',
    defaultMessage:
      'Start with the dropdown and the sliders below to easily estimate your potential benefits.',
  },
  reportTableHeading_2: {
    id: '3/uPTe',
    defaultMessage: 'Benefit value',
  },
  reportTableHeading_1: {
    id: 'rCMlHN',
    defaultMessage: 'Benefit category',
  },
  asstMgmtToolsCostDescTooltip: {
    id: 'M5Eo5f',
    defaultMessage:
      'Total current annual cost of asset management related applications and tools (including licensing, infrastructure, and support cost).',
  },
  maintenanceCostReduceTable: {
    id: 'YmJvtm',
    defaultMessage: 'Reduce external maintenance spend',
  },
  mroOverSpendReduceLabel: {
    id: 'sz0mWm',
    defaultMessage: '% MRO Spend Reduction',
  },
  getQuoteButton: {
    id: 'zEVTyS',
    defaultMessage: 'Get more information',
  },
  pdfError: {
    id: '2gydxl',
    defaultMessage: 'Your Export is incomplete',
  },
  widgetInfo: {
    id: 'vUy+lv',
    defaultMessage:
      'Learn how IBM Maximo delivers an average five-year ROI of 450%, according to this ',
  },
  downTimePerHrCostDescTooltip: {
    id: '43hx5I',
    defaultMessage:
      'Estimated average economic cost per downtime hour (e.g., cost of lost production, profit impact from lost sales)',
  },
  assetCapExOptTable: {
    id: 'wJphaF',
    defaultMessage: 'Extend useful life of assets',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  availableIn: {
    id: 'EPIw8h',
    defaultMessage: 'The MAS ROI is available in',
  },
  returnToROI: {
    id: 'E//Dx8',
    defaultMessage: 'Return to ROI',
  },
  GoToPEButton: {
    id: 'YbVY9t',
    defaultMessage: 'Price estimator',
  },
  downloadText: {
    id: 'TclprG',
    defaultMessage: 'Download PDF',
  },
  maintenancePersonProdTable: {
    id: 'xRglVq',
    defaultMessage: 'Increase maintenance productivity',
  },
  downTimeHoursAnnualLabel: {
    id: 'ziW66V',
    defaultMessage: 'Annual Downtime Hours',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  annualMroSpendDescTooltip: {
    id: 'Hurwlg',
    defaultMessage:
      'Annual spend in MRO materials and supplies used for maintaining and repairing assets.',
  },
  chartHeading: {
    id: 'yaMHMB',
    defaultMessage: 'Results',
  },
  maintenancePersonFTERateLabel: {
    id: 'MSiggH',
    defaultMessage: 'Average Maintenance Personnel - Annual Cost Rate',
  },
  widgetText_1: {
    id: 'WXSfCt',
    defaultMessage: 'See your potential benefit',
  },
  accordionDesc_6: {
    id: 'j05Xut',
    defaultMessage:
      'This benefit estimates the opportunity to reduce and consolidate disparate asset management related applications, tools, and associated IT costs.',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  extMaintVendorSpendReduceDescTooltip: {
    id: 't/HeD6',
    defaultMessage:
      'Estimated reduction in external maintenance vendor spend by reducing unnecessary maintenance activities and increasing the cost efficiency of necessary tasks.',
  },
  downTimePerHrCostLabel: {
    id: 'iytbrM',
    defaultMessage: 'Average Economic Cost of Downtime per hour',
  },
  reportSubHeading: {
    id: 'yMtFfC',
    defaultMessage: 'Your answer summary:',
  },
  discussMoreBtn: {
    id: 'LDcR4Y',
    defaultMessage: 'Discuss More',
  },
  contactInfo2: {
    id: 'fJD4UX',
    defaultMessage:
      'You may qualify for volume discounting! Request a quote for the best possible price.',
  },
  downTimeReduceLabel: {
    id: 'gPtYYm',
    defaultMessage: '% Downtime Reduction',
  },
  accordionDesc_1: {
    id: '8rqbR6',
    defaultMessage:
      'This benefit estimates the opportunity to increase the productivity of asset management and maintenance related roles such as Reliability Engineers, Maintenance Planners, Maintenance Supervisors, and Maintenance Technicians.',
  },
  accordionDesc_4: {
    id: 'qGy3Wi',
    defaultMessage:
      'This benefit estimates the opportunity to reduce asset replacement and overhaul cost by extending the economic and average useful life of assets and equipment.',
  },
  category: {
    id: 'ccXLVi',
    defaultMessage: 'Category',
  },
  accordionDesc_5: {
    id: 'xfXaOY',
    defaultMessage:
      'This benefit estimates the opportunity to reduce the spend for Maintenance, Repair, and Operations (MRO) materials and supplies that are used to maintain and repair assets.',
  },
  accordionDesc_2: {
    id: 'cUkc/u',
    defaultMessage:
      'This benefit estimates the opportunity to reduce or avoid cost related to maintenance services provided by external providers.',
  },
  accordionDesc_3: {
    id: 'GftFDv',
    defaultMessage:
      'This benefit estimates the opportunity to reduce the economic cost of planned or unplanned downtime by improving the availability and performance of assets. ',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  disclaimer_text: {
    id: 'NQfJPA',
    defaultMessage:
      'The results shown are based on certain assumptions, including results achieved by IBM clients with financial and operational asset maintenance profiles comparable to the inputs you provided. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider IBM Maximo Application Suite as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage and configurations and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual ROI & benefit will vary depending on individual client configurations and conditions.',
  },
});

export default messages;
